import autosize from 'autosize';
import { iframeResizer } from 'iframe-resizer';
/**
 * @module directives/form/autosize
 */

/**
 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
 * @see https://github.com/jackmoore/autosize
 * @param {HTMLElement} [context=document.body] - Optional DOM context.
 */
export default function autosizeDirective(context = document.body) {
  autosize(context.querySelector('textarea[data-sw-autosize]'));
  context.querySelectorAll('iframe[data-sw-autosize]').forEach(element => {
    iframeResizer({ checkOrigin: false }, element);
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/autosize.js